import React from "react";
import Badge from "react-bootstrap/Badge";

export default function StatusBadge({ status }) {
  if (!status) return null;

  const s = String(status).toLowerCase();

  let bg = "secondary";
  let label = status;

  if (s.includes("validée") || s.includes("confirm")) {
    bg = "success";
    label = "Validée";
  } else if (s.includes("attente")) {
    bg = "warning";
    label = "En attente";
  } else if (s.includes("annul")) {
    bg = "danger";
    label = "Annulée";
  } else if (s.includes("refus")) {
    bg = "dark";
    label = "Refusée";
  } else if (s.includes("termin")) {
    bg = "primary";
    label = "Terminée";
  }

  return (
    <Badge bg={bg} className="status-badge">
      {label}
    </Badge>
  );
}
